import React, { Component, Fragment } from "react";
import { Route, Switch } from "react-router-dom";
import SurveyGestion from "./Gestion";
import SurveyCreationSteps from "./CreationSteps";
import { connect } from "react-redux";
import { setMenuLeftIndex } from "./../../redux/actions/menuActions";

const mapStateToProps = (state, ownProps) => {
  return {
    currentClient: state.currentClient,
    currentClientLabel: (state.currentClient || {}).label
  };
};

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    setMenuLeftIndex: index => {
      dispatch(setMenuLeftIndex(index));
    }
  };
};

class Survey extends Component {
  state = {};

  componentDidMount() {
    this.props.setMenuLeftIndex("questionnaire");
  }

  render() {
    const { match, currentUser, currentClientLabel } = this.props;
    const { url } = match;

    return (
      <Fragment>
        <Switch>
          <Route
            name="SurveyGestion"
            exact
            path={`${url}/`}
            component={props => <SurveyGestion {...props} currentUser={currentUser} />}
          />
          <Route
            name="SurveyCreationSteps"
            exact
            path={`${url}/creation`}
            component={props => <SurveyCreationSteps {...props} currentUser={currentUser} />}
          />
        </Switch>
      </Fragment>
    );
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Survey);



// WEBPACK FOOTER //
// src/pages/survey/Home.js